import { css } from '@emotion/css';

export const heightRestriction = (height: string) => css`
  height: ${height};
  // overflow-y: scroll;
  // overflow-x: visible; // for carousel arrows
`;
